/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface GetIoePreviewFindings200ResponseFindingsInner
 */
export interface GetIoePreviewFindings200ResponseFindingsInner {
    /**
     * 
     */
    ioeId?: string;
    /**
     * 
     */
    objectType?: string;
    /**
     * 
     */
    objectId?: string | null;
    /**
     * 
     */
    objectName?: string | null;
    /**
     * 
     */
    findingText?: string | null;
    /**
     * 
     */
    rawFinding?: { [key: string]: any; } | null;
    /**
     * 
     */
    detectedAt?: Date;
    /**
     * 
     */
    clientUUID?: string;
    /**
     * 
     */
    clientName?: string | null;
    /**
     * 
     */
    serviceproviderUUID?: string | null;
    /**
     * 
     */
    serviceproviderName?: string | null;
}

/**
 * Check if a given object implements the GetIoePreviewFindings200ResponseFindingsInner interface.
 */
export function instanceOfGetIoePreviewFindings200ResponseFindingsInner(value: object): value is GetIoePreviewFindings200ResponseFindingsInner {
    return true;
}

export function GetIoePreviewFindings200ResponseFindingsInnerFromJSON(json: any): GetIoePreviewFindings200ResponseFindingsInner {
    return GetIoePreviewFindings200ResponseFindingsInnerFromJSONTyped(json, false);
}

export function GetIoePreviewFindings200ResponseFindingsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIoePreviewFindings200ResponseFindingsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'ioeId': json['ioeId'] == null ? undefined : json['ioeId'],
        'objectType': json['objectType'] == null ? undefined : json['objectType'],
        'objectId': json['objectId'] === undefined ? undefined : json['objectId'] === null ? null : json['objectId'],
        'objectName': json['objectName'] === undefined ? undefined : json['objectName'] === null ? null : json['objectName'],
        'findingText': json['findingText'] === undefined ? undefined : json['findingText'] === null ? null : json['findingText'],
        'rawFinding': json['rawFinding'] === undefined ? undefined : json['rawFinding'] === null ? null : json['rawFinding'],
        'detectedAt': json['detectedAt'] == null ? undefined : (parseDateTime(json['detectedAt'])),
        'clientUUID': json['clientUUID'] == null ? undefined : json['clientUUID'],
        'clientName': json['clientName'] === undefined ? undefined : json['clientName'] === null ? null : json['clientName'],
        'serviceproviderUUID': json['serviceproviderUUID'] === undefined ? undefined : json['serviceproviderUUID'] === null ? null : json['serviceproviderUUID'],
        'serviceproviderName': json['serviceproviderName'] === undefined ? undefined : json['serviceproviderName'] === null ? null : json['serviceproviderName'],
    };
}

export function GetIoePreviewFindings200ResponseFindingsInnerToJSON(json: any): GetIoePreviewFindings200ResponseFindingsInner {
    return GetIoePreviewFindings200ResponseFindingsInnerToJSONTyped(json, false);
}

export function GetIoePreviewFindings200ResponseFindingsInnerToJSONTyped(value?: GetIoePreviewFindings200ResponseFindingsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ioeId': value['ioeId'],
        'objectType': value['objectType'],
        'objectId': value['objectId'],
        'objectName': value['objectName'],
        'findingText': value['findingText'],
        'rawFinding': value['rawFinding'],
        'detectedAt': value['detectedAt'] == null ? value['detectedAt'] : serializeDateTime(value['detectedAt']),
        'clientUUID': value['clientUUID'],
        'clientName': value['clientName'],
        'serviceproviderUUID': value['serviceproviderUUID'],
        'serviceproviderName': value['serviceproviderName'],
    };
}

